export default __webpack_public_path__ + "static/media/DHTable3Img.61b69640.PNG";